<template>
    <span class="ActionButton">
        <font-awesome-icon :icon="[IconPrefix, IconSuffix]" :variant="ButtonVariant" :size="ButtonSize" @click="ButtonClick" :class="DynamicClassName()" style="font-size: 20px;margin-right:1rem;" />
        <b-modal ref="component-modal" title="CONFIRM ACTION" hide-footer>
            <b-container>
                <b-form @submit="Save">
                    <b-row v-html="ConfirmationString">
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" @click="Save()">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </span>

</template>

<script>
    
    import { EventBus } from '../../services/event-bus.js';
    export default {
        props: [
            "RequiresConfirmation",
            "ConfirmationString",
            "Endpoint",
            "Payload",
            "PerformGlobalUpdate",
            "ButtonVariant",
            "ButtonString",
            "ButtonSize",
            "IconPrefix",
            "IconSuffix",
            "IconColor",
            "Method"
        ],
        data: function () {
            return {

            };
        },
        methods: {
            DynamicClassName() {
                return("pointer " + this.IconColor);
            },
            ShowModal() {
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            ButtonClick() {
                if (this.RequiresConfirmation) {
                    this.ShowModal()
                } else {
                    this.Save();
                }
            },
            Save() {
                this.$MasterAPI.ExecuteRequest(this.Method, this.Endpoint, this.Payload, this.SaveSuccess, () => { }, true);

            },
            SaveSuccess(response) {
                this.$refs['component-modal'].hide();
                //emit success response
                this.$emit("success", response.data.data);
                if (this.DispatchOnSuccess != null) {
                    this.DispatchOnSuccess.forEach(function (item) {
                        EventBus.$emit(item);
                    });
                }
                //Perform Global Updates
                if (this.PerformGlobalUpdate) {
                    this.$GlobalUpdate.ExecuteGlobalUpdate();
                }
            },
            HandleShown() {
                this.$refs.showfocus.focus();
            }
        },
        components: {

        },
        computed: {

        }
    }
</script>

<style scoped>
    
</style>